import { WORLD_H, WORLD_W } from '@tanky/shared';

const SKY_MARGIN = 500;

export class Camera {
  x = WORLD_W / 2;
  y = WORLD_H / 2;
  zoom = 1;
  vw = 1;
  vh = 1;
  /** Čas (s), kdy uživatel naposledy ručně hýbal kamerou. */
  manualAt = -Infinity;

  resize(vw: number, vh: number) {
    const wasFit = Math.abs(this.zoom - this.fitZoom()) < 1e-3 || this.vw === 1;
    this.vw = vw;
    this.vh = vh;
    if (wasFit) this.zoom = this.fitZoom();
    this.clamp();
  }

  fitZoom() {
    return Math.min(this.vw / WORLD_W, this.vh / WORLD_H);
  }

  get maxZoom() {
    return Math.max(this.fitZoom() * 4, 2);
  }

  clamp(loose = false) {
    this.zoom = Math.min(this.maxZoom, Math.max(this.fitZoom(), this.zoom));
    if (loose) {
      this.x = Math.min(WORLD_W + 300, Math.max(-300, this.x));
      this.y = Math.min(WORLD_H + 200, Math.max(-SKY_MARGIN, this.y));
      return;
    }
    const hw = this.vw / 2 / this.zoom;
    const hh = this.vh / 2 / this.zoom;
    this.x = hw * 2 >= WORLD_W ? WORLD_W / 2 : Math.min(WORLD_W - hw, Math.max(hw, this.x));
    if (hh * 2 >= WORLD_H) this.y = WORLD_H / 2 - 40 / this.zoom;
    else this.y = Math.min(WORLD_H - hh, Math.max(-SKY_MARGIN + hh, this.y));
  }

  toScreen(wx: number, wy: number) {
    return { x: (wx - this.x) * this.zoom + this.vw / 2, y: (wy - this.y) * this.zoom + this.vh / 2 };
  }

  toWorld(sx: number, sy: number) {
    return { x: (sx - this.vw / 2) / this.zoom + this.x, y: (sy - this.vh / 2) / this.zoom + this.y };
  }

  pan(dx: number, dy: number) {
    this.x -= dx / this.zoom;
    this.y -= dy / this.zoom;
    this.clamp();
  }

  zoomAt(sx: number, sy: number, factor: number) {
    const before = this.toWorld(sx, sy);
    this.zoom *= factor;
    this.clamp();
    const after = this.toWorld(sx, sy);
    this.x += before.x - after.x;
    this.y += before.y - after.y;
    this.clamp();
  }

  follow(tx: number, ty: number, dt: number, loose = false) {
    const k = 1 - Math.exp(-dt * 4);
    this.x += (tx - this.x) * k;
    this.y += (ty - this.y) * k;
    this.clamp(loose);
  }
}
